export default __webpack_public_path__ + "static/media/(39).94d2dc2f.jpg";